import {
  Alert,
  Box,
  Button,
  Grid,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ViewFields } from "./Fields";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useWhatsAppNumber } from "./provider";
import { useNavigate, useParams } from "react-router-dom";
import { tolocalDate } from "../../utilities/functions";
import TabsList from "../../ui/TabsList";
import CustomTable from "../../ui/CustomTable";
import ActiveCell from "../Companies/CompanyTable/ActiveCell";
import ModalBox from "../../ui/ModalBox";
import ErrorsList from "../../ui/ErrorsList";

const WhatsAppDetails = () => {
  const theme = useTheme();
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    state: { selected: whatsAppAccount },
    fetchOne,
    remove,
    removeNumber,
  } = useWhatsAppNumber();

  const tabs = [
    { title: "Numbers", num: whatsAppAccount?.numbers?.length || 0 },
  ];
  const [selectedCols, setSelectedCols] = useState("Numbers");

  const [OpenAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [number, setNumber] = useState();
  const [error, setError] = useState();

  const cols = [
    {
      label: "Number",
      name: "number",
      textLeft: true,
      headTextLeft: true,
    },
    {
      label: "Phone NumberId",
      name: "phoneNumberId",
    },
    {
      label: "Status",
      name: "isActive",
      customRender: ActiveCell,
    },
  ];

  useEffect(() => {
    fetchOne(id);
  }, [id]);

  const handleAddClose = () => {
    setOpenAdd(!OpenAdd);
  };

  const handleEditClose = () => {
    setOpenEdit(!openEdit);
  };

  const handleRemoveNumber = (id) => {
    try {
      removeNumber(id);
    } catch (error) {
      console.log(error, "error");
      setError({
        title: error.errors.message ? error.errors.message : "some thing wrong",
      });
    }
  };

  const handleDeleteAccount = () => {
    try {
      remove(id);
      navigate("/WhatsAppAccount");
    } catch (error) {
      console.log(error, "error");
      setError({
        title: error.errors.message ? error.errors.message : "some thing wrong",
      });
    }
  };

  return (
    <div>
      <Typography variant="Poster" component="h4">
        WhatsApp Account Details
      </Typography>
      {error ? (
        <Alert severity="error" sx={{ my: 3 }}>
          <ErrorsList error={error} />
        </Alert>
      ) : (
        ""
      )}
      <Paper
        elevation={0}
        sx={{
          p: theme.dimensions.padding,
          mt: theme.dimensions.mt,
          mb: theme.dimensions.mb,
          background: theme.color.PaperbgColor,
          width: "95%",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="Poster" component="h4" gutterBottom>
            Account Information
          </Typography>
          <Button
            variant="contained"
            style={{ background: "#FF4747" }}
            onClick={handleDeleteAccount}
          >
            Delete
          </Button>
        </Box>
        <Grid container spacing={2}>
          {ViewFields.map((f, index) => (
            <Grid
              item
              xs={6}
              sm={6}
              mt={2}
              key={index}
              sx={{ fontSize: "14px" }}
            >
              <span style={{ color: theme.color.PaperlabelColor }}>
                {f.label} {" : "}
              </span>
              {f.name === "isActive" ? (
                whatsAppAccount?.isActive ? (
                  <span style={{ color: "#4AA785" }}>
                    <FiberManualRecordIcon
                      fontSize="small"
                      sx={{ fontSize: 10, mr: 0.2 }}
                    />
                    Active
                  </span>
                ) : (
                  <span style={{ color: "rgba(0, 0, 0, 0.4)" }}>
                    <FiberManualRecordIcon
                      fontSize="small"
                      sx={{ fontSize: 10, mr: 0.2 }}
                    />
                    Inactive
                  </span>
                )
              ) : (
                <span
                  style={{
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                    maxWidth: "100%",
                    display: "inline-block",
                  }}
                >
                  {f.date
                    ? tolocalDate(whatsAppAccount?.[f.name])
                    : whatsAppAccount?.[f.name]}
                </span>
              )}
            </Grid>
          ))}
        </Grid>
      </Paper>

      <TabsList
        tabs={tabs}
        setSelectedCols={setSelectedCols}
        selectedCols={selectedCols}
      ></TabsList>

      <CustomTable
        empty={whatsAppAccount?.numbers?.length === 0}
        cols={cols}
        data={whatsAppAccount?.numbers || []}
        filters={{
          add: () => {
            setOpenAdd(!OpenAdd);
          },
        }}
        actions={{
          edit: (id, row) => {
            setNumber(row);
            setOpenEdit(!openEdit);
          },
          delete: handleRemoveNumber,
        }}
        isPagination={false}
      ></CustomTable>
      <ModalBox
        open={OpenAdd}
        operation="add"
        handleClose={handleAddClose}
        text="Add new number successfully..."
        name={`${selectedCols}`}
        whatsAppNumber={{ type: "Add", handleToggle: handleAddClose }}
      />

      <ModalBox
        open={openEdit}
        handleClose={handleEditClose}
        text="The update operation has been completed successfully.."
        name={`${selectedCols}`}
        whatsAppNumber={{
          type: "Edit",
          viewDate: number || null,
          handleToggle: handleEditClose,
        }}
      />
    </div>
  );
};

export default WhatsAppDetails;
